import { clientApplicationStatus } from "@revbox/common-fe"
import getClientApplicationById from "../services/micro/get_client_application_by_id"
import { editClientApplication } from "../services/micro/edit_client_application"

export async function changeStatus(newStatus, params) {
    try {
        params.node.setDataValue('client_application_status', newStatus)
        const application = await getClientApplicationById(params.node.data.id)
        const { publisher_id, main_category, id, owner_id } = application.data
        console.log(application.data, params.node.data)
        const data = {
            ...params.node.data,
            client_application_status: clientApplicationStatus[newStatus],
            main_category,
            publisher_id,
            owner_id
        }

        await editClientApplication(id, data)
    } catch (error) {
        console.error(`Error changing status to ${newStatus}:`, error)
    }
}